// extracted by mini-css-extract-plugin
export default {"filtersWrapper":"inputSearch_filtersWrapper__LTHGJ"};